import { when } from '@execonline-inc/maybe-adapter';
import { Maybe, fromEmpty } from 'maybeasy';
import { includes } from '../../../../../Collections';
import { valueFor } from '../../../../../ListFilter';
import { SearchParameter, SearchParameters } from '../../../../../ListFilter/Types';
import { NumberOption } from '../../../../Options/Types';

const currentOwnerValueM = (searchParameters: SearchParameters): Maybe<string> =>
  fromEmpty(valueFor('owner', searchParameters));

const alreadyChecked = (numberParams: number[], value: number) =>
  when(numberParams.includes(value), numberParams);

const handleCheckedOrNotChecked = (
  params: string,
  value: number,
  updatingSearchParameters: (searchParameter: SearchParameter) => void,
) => {
  const numberParams = params.split(',').map((value) => parseInt(value));
  alreadyChecked(numberParams, value)
    .do((numberParams) =>
      updatingSearchParameters({
        key: 'owner',
        value: String(numberParams.filter((number) => number != value)),
      }),
    )
    .elseDo(() => {
      numberParams.push(value);
      return updatingSearchParameters({
        key: 'owner',
        value: String(numberParams),
      });
    });
};

export const handleOnClick =
  (
    updatingSearchParameters: (searchParameter: SearchParameter) => void,
    option: NumberOption,
    searchParameters: SearchParameters,
  ) =>
  () => {
    currentOwnerValueM(searchParameters)
      .do((params) => handleCheckedOrNotChecked(params, option.value, updatingSearchParameters))
      .elseDo(() => updatingSearchParameters({ key: 'owner', value: String(option.value) }));
  };

export const checkboxCondition = (
  option: NumberOption,
  searchParameters: SearchParameters,
): boolean => includes(String(option.value), valueFor('owner', searchParameters).split(','));
